import { createSlice } from '@reduxjs/toolkit'
import { ThemeMode } from '../../typing/enums'
import { THEME_KEYS } from './theme.constants'

export type ThemeState = {
  [THEME_KEYS.mode]: ThemeMode,
}

const initialState: ThemeState = {
  [THEME_KEYS.mode]: ThemeMode.light,
}

const themeSlice = createSlice({
  name: THEME_KEYS.sliceName,
  initialState,
  reducers: {
    toggleThemeMode: state => {
      state[THEME_KEYS.mode] = (state[THEME_KEYS.mode] === ThemeMode.light)
        ? ThemeMode.dark
        : ThemeMode.light
    },
  },
})

export const { toggleThemeMode } = themeSlice.actions
export default themeSlice.reducer
